import script from "./goodInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./goodInfoList.vue?vue&type=script&setup=true&lang=js"

import "./goodInfoList.vue?vue&type=style&index=0&id=1048094c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1048094c"]])

export default __exports__